import { useTranslation } from 'react-i18next';

export default function AboutSection() {
  const { t } = useTranslation();

  return (
    <section className="py-20 md:py-28 px-4 md:px-6 bg-white">
      <div className="max-w-[900px] mx-auto text-center">
        <span className="inline-block px-6 py-2 border border-foreground-200 rounded-full text-xs font-label text-foreground-600 uppercase tracking-wider">
          {t('about.label')}
        </span>

        <h2 className="mt-8 font-heading text-4xl md:text-5xl lg:text-6xl font-light text-foreground-950 leading-[1.5] tracking-tight">
          <span className="flex items-center justify-center gap-3 flex-wrap">
            {t('about.title_line1')}
            <span className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center">
              <i className="ri-shopping-bag-3-line text-3xl md:text-4xl text-accent-500"></i>
            </span>
          </span>
          <span className="flex items-center justify-center gap-3 flex-wrap">
            {t('about.title_line2')}
            <span className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center">
              <i className="ri-table-line text-3xl md:text-4xl text-accent-500"></i>
            </span>
          </span>
          <span className="flex items-center justify-center gap-3 flex-wrap">
            {t('about.title_line3')}
            <span className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center">
              <i className="ri-archive-line text-3xl md:text-4xl text-accent-500"></i>
            </span>
          </span>
        </h2>
      </div>
    </section>
  );
}